import { RedeemUspTray } from '../../../domain/redeem-usp-tray';
import {
  BulletPointStyleApiModel,
  CreateMarketingBulletedUspPageItemApiModel,
  LocalizedOrderedTextApiModel,
  MarketingBulletedUspPageItemApiModel,
  TitleStyleApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, PlatformType, remainderMapper } from 'osn-shared';
import { localizedDataMapper } from '../../mapping/create-tray-api-domain-common';
import { localizedBackgroundImagesMapper, mapDomainCtaLayoutToApi } from '../../mapping/create-tray-domain-to-api';
import { LocalizedFormData } from '../../common/localized-form-data';
import { backgroundImagesMapperApiToDomain, commonMapper, mapApiCtaLayoutToDomain } from '../../mapping/create-tray-api-to-domain';
import { RedeemUspTrayFormViewModel } from './redeem-usp-tray-form-view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  mapLocalizedDomainImagesToPlatformLocalizedViewModelImage,
  mapMarketingItemLayoutToTraySelectorType,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import { localizedFormDataMapper } from '../create-tray-screen/mapping/create-tray-domain-vm-common';
import {
  mapTraySelectorTypeToMarketingItemLayout,
  mapViewModelImagesToLocalizedDomainImages,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'RedeemUspTray'

/**
 * DOMAIN -> API
 */

const mapDomainRedeemUspBulletPointsToApi = (bulletPoints: LocalizedFormData<string>[]): LocalizedOrderedTextApiModel[] => {
  return bulletPoints.map((bulletPoint, i) => ({
    ar: bulletPoint.ar,
    en: bulletPoint.en,
    order: i,
  }));
};

export const mapDomainRedeemUspTrayToApi = (
  redeemUspTray: RedeemUspTray,
  pageVersionId: string,
  tenantId?: string
): CreateMarketingBulletedUspPageItemApiModel => {
  const commonProperties = mapperPipe(redeemUspTray, localizedBackgroundImagesMapper);

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    layout: mapDomainCtaLayoutToApi(redeemUspTray.template),
    name: redeemUspTray.titleEnglish,
    bulletPoints: mapDomainRedeemUspBulletPointsToApi(redeemUspTray.bulletPoints),
    bulletPointStyle: BulletPointStyleApiModel.Light,
    titleLocalized: localizedDataMapper(redeemUspTray.headlineText),
    titleStyle: TitleStyleApiModel.Light,
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapApiRedeemUspTrayToDomain = (redeemUspTray: MarketingBulletedUspPageItemApiModel): RedeemUspTray => {
  return remainderMapper(mapperPipe(redeemUspTray, commonMapper, backgroundImagesMapperApiToDomain), () => ({
    type: 'RedeemUspTray',
    titleEnglish: redeemUspTray.name,
    template: mapApiCtaLayoutToDomain(redeemUspTray.layout),
    bulletPoints: redeemUspTray.bulletPoints,
    headlineText: localizedDataMapper(redeemUspTray.titleLocalized),
  }));
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapDomainRedeemUspTrayToViewModel = (redeemUspTray: RedeemUspTray): RedeemUspTrayFormViewModel => {
  return {
    id: redeemUspTray.id,
    bulletPoints: redeemUspTray.bulletPoints,
    type: TrayFormViewModelType.RedeemUspTray,
    name: redeemUspTray.titleEnglish,
    headlineText: redeemUspTray.headlineText,
    template: mapMarketingItemLayoutToTraySelectorType(redeemUspTray.template),
    images: mapLocalizedDomainImagesToPlatformLocalizedViewModelImage(redeemUspTray.backgroundImages),
  };
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapViewModelRedeemUspTrayToDomain = (
  redeemUspTray: RedeemUspTrayFormViewModel,
  platformIds: Record<PlatformType, string> //TODO:MK
): RedeemUspTray => {
  return {
    id: redeemUspTray.id || '',
    type: 'RedeemUspTray',
    order: undefined,
    visible: undefined,
    draggable: true,
    headlineText: localizedFormDataMapper(redeemUspTray.headlineText),
    titleEnglish: redeemUspTray.name,
    bulletPoints: redeemUspTray.bulletPoints,
    backgroundImages: mapViewModelImagesToLocalizedDomainImages(redeemUspTray.images, platformIds),
    template: mapTraySelectorTypeToMarketingItemLayout(redeemUspTray.template),
    platformIds: [], // TODO:MK
  };
};
